import { resource } from '@/plugins/http'

export default resource('/v1/patient/settings/profiles/me')



// WEBPACK FOOTER //
// ./src/store/resources/patient.js